import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    throw new Error(body?.message || 'Request failed')
  }
  return body.data
}

function apiError(err: unknown, fallback: string) {
  const e = err as { response?: { data?: { message?: string } }; message?: string }
  return new Error(e?.response?.data?.message || e?.message || fallback)
}

export type AdminPaystackPayoutStatus = {
  storeId: number
  recipientCode: string | null
  bankCode: string | null
  accountNumberLast4: string | null
  accountName: string | null
  recipientActive: boolean
  autoWithdraw: string
  readyForPayout: boolean
  currencyEligible: boolean
  paystackConfigured: boolean
}

export async function getStorePaystackPayout(
  storeId: number | string,
): Promise<AdminPaystackPayoutStatus> {
  try {
    const { data } = await api.get(`/admin/stores/${encodeURIComponent(String(storeId))}/paystack/payout`)
    return assertSuccess(data) as AdminPaystackPayoutStatus
  } catch (e) {
    throw apiError(e, 'Failed to load Paystack payout status')
  }
}
